export default () => ({
  visible: false,
  init() {
    this.onPageShow({ persisted: false });
  },
  onPageShow(event) {
    const navigation = performance.getEntriesByType('navigation')[0];
    this.visible = this.visible || event.persisted || navigation?.type === 'back_forward';
  },
  onClick(event) {
    if (event.target.closest('a')) {
      event.preventDefault();
      window.location.reload();
    }
  },
});
